import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useUrlSearchParams } from 'use-url-search-params';
import { Card, Button, OverlayTrigger, Form, Tooltip } from 'react-bootstrap';
import toast, { Toaster } from 'react-hot-toast';
import { Badge } from 'reactstrap';
import CsLineIcons from '../../../cs-line-icons/CsLineIcons';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import Pagination from '@vlsergey/react-bootstrap-pagination';
import { fetchRefundDetails } from '../action/action';
import { SORTING_ORDER } from '../../../constants/index';
import moment from 'moment';
import axios from 'axios';
import UserAuthKey from '../../../components/Common/UserAuthKey';
import { setUserData } from '../../../Redux/user/userSlice';
import { FINANCE_ROLE_ID, FINANCE_MANAGER_ROLE_ID, AUDIT_ROLE_ID, SHOW_ROOM_MANAGER_ROLE_ID, CUSTOMER_CARE_MANAGER_ROLE_ID, CUSTOMER_CARE_SUPERVISOR_ROLE_ID, STORE_CUSTOMER_CARE_SUPERVISOR_ROLE_ID } from '../../../constants/roles'; // Import the role constants

import {
  Table,
  Row,
  Col,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Spinner,
} from 'reactstrap';
import BankInfo from './BankInfo';
import ReactDrawer from 'react-drawer';
import 'react-drawer/lib/react-drawer.css';
import DHPagination from '../../../components/Pagination';
import FilterSearchQueue from '../../../components/FilterSearch/FilterSearchQueue';

import './BankRefundList.css';
import { color } from 'echarts/lib/export';

const BankRefundList = (props) => {
  const { stores } = props;
  const location = useLocation();
  const [btnprimary, setBtnprimary] = useState(false);
  const dispatch = useDispatch();
  const [copiedId, setCopiedId] = useState(null);
  const [sortingName, setSortingName] = useState({ id: 'sort.date_asc' });
  const [paginationValue, setPaginationValue] = useUrlSearchParams({ page: 0 });
  const [limitValue, setLimitValue] = useUrlSearchParams({ limit: 10 });
  const [sortingValue, setSortingValue] = useUrlSearchParams({
    sort: '_date',
    order: SORTING_ORDER.ASC,
  });
  const [searchValue, setSearchValue] = useUrlSearchParams({ search: '' });

  let is_split = 0;
  const { country = [] } = useSelector((state) => state.country);
  let currentCountry = localStorage.getItem('WEBSITE_COUNTRY');
  const splitVal = location?.pathname.split('/');
  const [advancedFilter, setAdvancedFilter] = useState({});
  const [searchFilter, setSearchFilter] = useUrlSearchParams({ search: '' });
  const [statusFilter, setStatusFilter] = useUrlSearchParams({ status: 'All' });
  const handleCopyData = (data, id) => {
    navigator.clipboard.writeText(data);
    setCopiedId(id);
  };

  const fetchRefundList = useCallback(async (data) => {
    try {
      setDataLoading(true);
      await fetchRefundDetails({
        params: data,
        dispatch,
      }); // send data directly, not { params: data }
    } catch (error) {
      setDataLoading(false);
      console.error('Error fetching orders:', error);
    } finally {
      setDataLoading(false);
    }
  }, []);

  useEffect(() => {
    const delay = setTimeout(() => {
      fetchRefundList({
        start: Number(paginationValue.page * limitValue.limit),
        limit: Number(limitValue.limit),
        sort: { value: sortingValue.sort, order: Number(sortingValue.order) },
        search_qry: searchValue.search,
        status: statusFilter.status || 'All',
        orderBy: 'id',
        country: currentCountry,
        advancedFilter,
        stores,
      });
    }, 300);
    return () => clearTimeout(delay);
  }, [
    paginationValue.page,
    limitValue,
    advancedFilter,
    searchFilter,
    statusFilter,
    stores,
  ]);

  const paymentLabel = {
    payfort_fort_cc: 'Payfort',
    payfort: 'Payfort',
    payfort_fort_installments: 'Payfort',
    apple_pay: 'Payfort',
    payfort_omannet: 'Payfort',
    tamara: 'Tamara',
    tabby: 'Tabby',
    Wallet: 'Wallet',
  };

  // A rejected refund can still be settled by crediting the customer's wallet
  const isWalletRefund = (order) => {
    const flag = order?.Wallet ?? order?.wallet ?? order?.is_wallet ?? order?.IsWallet;
    return flag === 1 || flag === '1' || flag === true;
  };

  const limitByValues = [5, 10, 20, 50];
  const { refundList = [], isLoading } = useSelector((state) => state.refund);

  const [isDataLoading, setDataLoading] = useState(false);

  const { listOrders } = refundList;
  const refundData = listOrders?.refundList;

  let LsSts = 'New';

  const sortByValues = [
    { key: 'date', order: SORTING_ORDER.ASC, label: { id: 'sort.date_asc' } },
    { key: 'date', order: SORTING_ORDER.DESC, label: { id: 'sort.date_desc' } },
    {
      key: 'status',
      order: SORTING_ORDER.ASC,
      label: { id: 'sort.status_asc' },
    },
    {
      key: 'status',
      order: SORTING_ORDER.DESC,
      label: { id: 'sort.status_desc' },
    },
  ];

  let UserRoleID = '';
  let UserCountry = '';

  if (localStorage.getItem('authUser')) {
    const userObj = JSON.parse(localStorage.getItem('authUser'));
    if (userObj?.role_id !== undefined) {
      UserRoleID = userObj?.role_id;
      UserCountry = userObj?.country;
    }
  }

  let pageIndex = Number(listOrders?.start);

  async function generateConsentPdf(order) {
    const bearerToken = UserAuthKey();
    let country = localStorage.getItem('WEBSITE_COUNTRY') || '';
    const config = {
      method: 'POST',
      url: `${process.env.REACT_APP_OMS_API}v1/orders/consentform?country=${country}&transaction_reference=${order.TransactionReference}&receiver_type=admin`,
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        'Content-Type': 'application/json',
      },
    };
    try {
      const response = await axios(config);
      if (response?.data?.code === 100 && response?.data?.data) {
        console.log(response.data.data, 'url');
        window.location.href = response.data.data;
      } else {
        if (response?.data?.message) {
          // Optionally show a toast or alert
          alert(response.data.message);
        }
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        dispatch(setUserData(null));
        window.location.replace('/logout');
      } else {
        alert('Failed to generate consent form.');
      }
    }
  }

  // State to manage which BankInfo drawer is open and in which mode
  const [drawerState, setDrawerState] = useState({
    open: false,
    order: null,
    editMode: false,
  });
  const [viewMode, setViewMode] = useState(false);

  const handleOpenDrawer = (order, editMode = false) => {
    setDrawerState({ open: true, order, editMode });
    if (!editMode) {
      setViewMode(true); // Activate viewMode only when clicking 'View Bank Info'
    } else {
      setViewMode(false); // Deactivate viewMode for other actions
    }
  };
  const handleCloseDrawer = () => {
    setDrawerState({ open: false, order: null, editMode: false });
    setViewMode(false);
  };

  const customStyles = `
  .refundOrder .react-drawer-drawer {
    width: ${viewMode ? '50%' : ''} !important;
  }
`;

  async function regenerateBankInfoFillLink(order) {
    const bearerToken = UserAuthKey();

    // Show loader
    setDataLoading(true);

    // Prepare the data structure
    const requestData = {
      reference_no: order.TransactionReference,
      amount: parseFloat(order.Amount),
      full_name: order.FullName,
      store_name: order.StoreId,
      email: order?.email || '', // Replace with dynamic email if available
      phone: order?.Mobile || '', // Replace with dynamic phone if available
      country: order.Country.toUpperCase(),
      refund_reason: 'customer', // Replace with dynamic reason if available
      refund_reason_primary: order?.RefundReason || '', // Replace with dynamic primary reason if available
      refund_reason_specific: '', // Replace with dynamic specific reason if available
      remarks: '', // Replace with dynamic remarks if available
      action: 'regenerate',
      parent_requestId: order?.id || '' // Include previous RequestId to link with the original request
    };

    const config = {
      method: 'POST',
      url: `${process.env.REACT_APP_OMS_API}v1/orders/save-refund-details`,
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        'Content-Type': 'application/json',
      },
      data: requestData,
    };

    try {
      const response = await axios(config);
      console.log(response?.data?.code, 'res');
      if (response?.data?.code === 100) {
        toast.success('Successfully submitted', {
          style: {
            border: '1px solid #fff',
            padding: '20px',
            color: '#ffffff',
            background: '#4CAF50',
          },
          iconTheme: {
            primary: '#FFFAEE',
            secondary: '#4CAF50',
          },
        });

        // Reload the refund list after success
        fetchRefundList({
          start: Number(paginationValue.page * limitValue.limit),
          limit: Number(limitValue.limit),
          sort: { value: sortingValue.sort, order: Number(sortingValue.order) },
          search_qry: searchValue.search,
          status: statusFilter.status || 'All',
          orderBy: 'id',
          country: currentCountry,
          advancedFilter,
          stores,
        });
      } else {
        toast.error('Failed to regenerate link.', {
          style: {
            border: '1px solid #fff',
            padding: '20px',
            color: '#ffffff',
            background: '#f44336',
          },
          iconTheme: {
            primary: '#FFFAEE',
            secondary: '#f44336',
          },
        });
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        dispatch(setUserData(null));
        window.location.replace('/logout');
      } else {
        alert('An error occurred while regenerating the link.');
      }
    } finally {
      // Hide loader
      setDataLoading(false);
    }
  }

  const handleUpdateRefundListTrigger = useCallback((triggerValue) => {
    setAdvancedFilter((prev) => ({ ...prev, trigger: triggerValue }));
  }, []);

  return (
    <>
      <>
        <style>{customStyles}</style>
        <Row>
          <Col xl={12}>
            <FilterSearchQueue
              type="bankrefund"
              setAdvancedFilter={setAdvancedFilter}
              setSearchFilter={setSearchFilter}
              setStatusFilter={setStatusFilter}
            />
            <>
              <div className=" dt-table">
                <div className="table-responsive">
                  <Table className="OrderListTable table mb-0">
                    <thead>
                      <tr>
                        <th>SI.No</th>
                        <th>Date</th>
                        <th>Reference No</th>
                        <th>Return Date</th>
                        <th>Store</th>
                        <th>Customer Name</th>
                        <th>Refund Amount</th>
                        <th>link</th>
                        <th>Reason</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    {isLoading || isDataLoading ? (
                      <>
                        <Spinner className="ms-2 sploader" color="primary" />
                        <tbody>
                          {[...Array(2)].map((_, index) => (
                            <tr>
                              <td>
                                <p className="placeholder-glow">
                                  <span className="placeholder col-2"></span>
                                </p>
                              </td>
                              <td>
                                <p className="placeholder-glow">
                                  <span className="placeholder col-12"></span>
                                  <span className="placeholder col-6"></span>
                                  <span
                                    className="placeholder"
                                    style={{ width: '25%' }}
                                  ></span>
                                  <span className="placeholder w-75"></span>
                                </p>
                              </td>
                              <td>
                                <p className="placeholder-glow">
                                  <span className="placeholder col-8"></span>
                                </p>
                              </td>
                              <td>
                                <p className="placeholder-glow">
                                  <span className="placeholder col-8"></span>
                                </p>
                              </td>
                              <td>
                                {' '}
                                <p className="placeholder-glow d-flex flex-column gap-1">
                                  <span className="placeholder col-6"></span>
                                </p>
                              </td>
                              <td>
                                {' '}
                                <p className="placeholder-glow">
                                  <span className="placeholder col-6"></span>
                                </p>
                              </td>
                              <td>
                                {' '}
                                <p className="placeholder-glow">
                                  <span className="placeholder col-6"></span>
                                </p>
                              </td>
                              <td>
                                {' '}
                                <p className="placeholder-glow">
                                  <span className="placeholder col-6"></span>
                                </p>
                              </td>
                              <td>
                                <p className="placeholder-glow">
                                  <span className="placeholder col-6"></span>
                                  <span
                                    className="placeholder"
                                    style={{ width: '25%' }}
                                  ></span>
                                </p>
                              </td>
                              <td colSpan={2}></td>
                            </tr>
                          ))}
                        </tbody>
                      </>
                    ) : refundData?.length > 0 ? (
                      <>
                        {(refundData || []).map((order, index) => {
                          pageIndex++;
                          let cdate = order.CreatedAt,
                            orderDt = moment(new Date(cdate)).format(
                              'Do MMM, YYYY'
                            ),
                            orderTime = moment(new Date(cdate)).format(
                              'h:mm:ss a'
                            );
                          const referenceNo =
                            order?.reference_no ||
                            order?.ReferenceNo ||
                            order?.TransactionReference ||
                            'N/A';
                          const returnDateRaw =
                            order?.LsReturnDate ||
                            order?.return_date ||
                            order?.ReturnDate ||
                            order?.ls_return_date ||
                            order?.LSReturnDate ||
                            order?.lsreturn_date;
                          const returnDate = returnDateRaw
                            ? moment(new Date(returnDateRaw)).isValid()
                              ? moment(new Date(returnDateRaw)).format(
                                'Do MMM, YYYY'
                              )
                              : returnDateRaw
                            : 'N/A';
                          return (
                            <tbody key={index}>
                              <tr>
                                <th scope="row">{pageIndex}</th>
                                <td>
                                  <strong>{order.TransactionReference}</strong>
                                  {order?.StoreId === 'DHECOMM' && (
                                    <a
                                      href={`https://betaoms.danubehome.com/splitorders?status=All&search=${order.TransactionReference}&page=0&limit=10`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="ms-2"
                                    >
                                      <i className="bx bx-link-external"></i>
                                    </a>
                                  )}
                                  <br />
                                  <span className="fs-11">
                                    {orderDt} {orderTime}
                                  </span>
                                  <p className="fs-11">
                                    <b>Created By :</b>
                                    {order.userName}
                                  </p>
                                </td>
                                <td>{referenceNo}</td>
                                <td>{returnDate}</td>
                                <td className="ReturnInfo1">
                                  {order?.StoreId || 'Online'}
                                  <span className="noTxtWrap">
                                    {order.Country}
                                  </span>
                                </td>
                                <td>
                                  {order?.FullName}
                                  <span className="d-block">
                                    <strong>Mobile : </strong> {order.Mobile}
                                  </span>
                                </td>

                                <td>{order?.Currency} <strong className='fs-6'>{order?.Amount}</strong>
                                  <span className="d-block"><strong>Refund Uid : </strong> {order?.BannkRefundId}</span>
                                </td>
                                <td>
                                  <span
                                    className={`copy-btn ${copiedId === order?.Link ? 'copied' : ''
                                      }`}
                                    onClick={() => {
                                      handleCopyData(order?.Link, order?.Link);
                                    }}
                                  >
                                    <i className="bx bx-copy-alt"></i>{' '}
                                    {copiedId === order?.Link
                                      ? 'Copied'
                                      : 'Copy Link'}{' '}
                                  </span>
                                  <span>
                                    <a
                                      className="link-btn"
                                      href={order?.Link}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <i className="bx bx-link-external"></i>
                                    </a>
                                  </span>
                                </td>
                                <td>
                                  <strong className="label-equal-width">
                                    Primary :
                                  </strong>
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip>
                                        {order?.RefundReason || 'N/A'}
                                      </Tooltip>
                                    }
                                  >
                                    <span>
                                      {order?.RefundReason?.length > 40
                                        ? `${order.RefundReason.substring(
                                          0,
                                          40
                                        )}...`
                                        : order?.RefundReason || 'N/A'}
                                    </span>
                                  </OverlayTrigger>
                                  {order?.RefundReasonPrimary && (
                                    <span className="d-block">
                                      <strong className="label-equal-width">
                                        Secondary :
                                      </strong>
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip>
                                            {order.RefundReasonPrimary}
                                          </Tooltip>
                                        }
                                      >
                                        <span>
                                          {order.RefundReasonPrimary.length > 40
                                            ? `${order.RefundReasonPrimary.substring(
                                              0,
                                              40
                                            )}...`
                                            : order.RefundReasonPrimary}
                                        </span>
                                      </OverlayTrigger>
                                    </span>
                                  )}
                                  {order?.RefundReasonSpecific && (
                                    <span className="d-block">
                                      <strong className="label-equal-width">
                                        Specific :
                                      </strong>
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip>
                                            {order.RefundReasonSpecific}
                                          </Tooltip>
                                        }
                                      >
                                        <span>
                                          {order.RefundReasonSpecific.length >
                                            40
                                            ? `${order.RefundReasonSpecific.substring(
                                              0,
                                              40
                                            )}...`
                                            : order.RefundReasonSpecific}
                                        </span>
                                      </OverlayTrigger>
                                    </span>
                                  )}
                                </td>
                                <td>
                                  {order?.Status === '0' && (
                                    <span className="badge bg-soft-secondary text-dark">
                                      Pending
                                    </span>
                                  )}
                                  {order?.Status === '1' && (
                                    <span className="badge bg-soft-warning text-dark">
                                      Approval Pending
                                    </span>
                                  )}
                                  {order?.Status === '2' && (
                                    <span className="badge bg-soft-info text-dark">
                                      Approved
                                    </span>
                                  )}
                                  {order?.Status === '3' && (
                                    <span className="badge bg-soft-success text-dark">
                                      Completed
                                    </span>
                                  )}
                                  {order?.Status === '4' && (
                                    <span className="badge bg-soft-warning text-dark">
                                      Clarification Required{' '}
                                    </span>
                                  )}
                                  {order?.Status === '5' && (
                                    <>
                                      <span className="badge bg-soft-danger text-dark">
                                        Rejected{' '}
                                      </span>
                                      {isWalletRefund(order) && (
                                        <span className="text-success d-block mt-1 fs-12 fw-semibold">
                                          <i className="bx bx-wallet me-1"></i>
                                          Amount transferred to wallet
                                        </span>
                                      )}
                                    </>
                                  )}
                                  {order?.Status === '6' && (
                                    <span className="badge bg-soft-danger text-dark">
                                      Closed{' '}
                                    </span>
                                  )}
                                  {order?.Status === '7' && (
                                    <span className="badge bg-soft-warning text-dark">
                                      Finance Mngr Approval pending
                                    </span>
                                  )}
                                  {order?.Status === '8' && (
                                    <span className="badge bg-soft-warning text-dark">
                                      Showroom Mngr approval pending
                                    </span>
                                  )}
                                  {order?.Status === '13' && (
                                    <span className="badge bg-soft-danger text-dark">
                                      Showroom Mngr Rejected
                                    </span>
                                  )}


                                  {order?.Status === '9' && (
                                    <span className="badge bg-soft-warning text-dark">
                                      Finance approval pending
                                    </span>
                                  )}
                                  {order?.Status === '10' && (
                                    <span className="badge bg-soft-success text-dark">
                                      Finance Manager Approval Pending
                                    </span>
                                  )}
                                  {order?.Status === '11' && (
                                    <span className="badge bg-soft-danger text-dark">
                                      Finance Rejected
                                    </span>
                                  )}
                                  {order?.Status === '20' && (
                                    <span className="badge bg-soft-warning text-dark">
                                      Audit Approval Pending
                                    </span>
                                  )}

                                  {![
                                    '0',
                                    '1',
                                    '2',
                                    '3',
                                    '4',
                                    '5',
                                    '6',
                                    '7',
                                    '8',
                                    '9',
                                    '10',
                                    '11',
                                    '13',
                                    '20'
                                  ].includes(String(order?.Status)) && (
                                      <span className="badge bg-secondary">
                                        Pending
                                      </span>
                                    )}
                                  {order?.RefundReference && (
                                    <span className="text-muted d-block mt-1">
                                      <strong>Refund Reference:</strong>{' '}
                                      {order.RefundReference}
                                    </span>
                                  )}
                                  {(order?.Status === '6' && order?.Regenerated != 1) && (
                                    <span
                                      className="ms-2 btn btn-sm btn-outline-primary waves-effect waves-light"
                                      title="Regenerate Bank Info Fill Link"
                                      onClick={() =>
                                        regenerateBankInfoFillLink(order)
                                      }
                                    >
                                      <i className="bx bx-refresh"></i>{' '}
                                      Regenerate Link
                                    </span>
                                  )}
                                </td>
                                <td>
                                  <div className="action-flex-container">
                                    {order?.Status != '0' && (
                                      <span
                                        className="btn btn-sm btn-outline-warning waves-effect waves-light"
                                        title="Generate PDF Consent Form"
                                        onClick={() =>
                                          generateConsentPdf(order)
                                        }
                                      >
                                        <i className="bx bx-download"></i>
                                      </span>
                                    )}
                                    {(['1', '2', '4', '0'].includes(
                                      String(order?.Status)
                                    ) ||
                                      (FINANCE_ROLE_ID.includes(UserRoleID) &&
                                        order?.Status === '9') ||
                                      (FINANCE_MANAGER_ROLE_ID.includes(UserRoleID) &&
                                        order?.Status === '10') ||
                                      (AUDIT_ROLE_ID.includes(UserRoleID) &&
                                        order?.Status === '20') || (UserRoleID === SHOW_ROOM_MANAGER_ROLE_ID &&
                                          order?.Status === '8') || (UserRoleID === CUSTOMER_CARE_MANAGER_ROLE_ID &&
                                            order?.Status === '7') || ((UserRoleID === CUSTOMER_CARE_SUPERVISOR_ROLE_ID || UserRoleID === STORE_CUSTOMER_CARE_SUPERVISOR_ROLE_ID) &&
                                              (order?.Status === '11' || order?.Status === '13' || order?.Status === '15'))) && (
                                        <span
                                          className="btn btn-sm btn-outline-warning waves-effect waves-light"
                                          title="Edit Refund information"
                                          onClick={() =>
                                            handleOpenDrawer(order, true)
                                          }
                                        >
                                          <i className="mdi mdi-border-color "></i>
                                        </span>
                                      )}
                                    {order?.Status != '0' && (
                                      <span
                                        className="btn btn-sm btn-outline-warning waves-effect waves-light"
                                        title="View Bank Info"
                                        onClick={() => {
                                          setViewMode(true); // Activate viewMode explicitly for 'View Bank Info'
                                          handleOpenDrawer(order, false);
                                        }}
                                      >
                                        <i className="mdi mdi-eye-outline"></i>
                                      </span>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          );
                        })}
                      </>
                    ) : (
                      <>
                        <tbody>
                          <tr>
                            <td colSpan={11}>No Records found</td>
                          </tr>
                        </tbody>
                      </>
                    )}
                  </Table>
                </div>
                {refundData?.length > 0 ? (
                  <DHPagination
                    totalPages={listOrders?.recordsTotal}
                    currentPage={paginationValue.page}
                    setPaginationValue={setPaginationValue}
                    setLimitValue={setLimitValue}
                  />
                ) : null}
              </div>
            </>
          </Col>
        </Row>
        <ReactDrawer
          open={drawerState.open}
          position="right"
          onClose={handleCloseDrawer}
        >
          {drawerState.open && (
            <BankInfo
              refundData={drawerState.order}
              editMode={drawerState.editMode}
              onClose={handleCloseDrawer}
              onUpdateRefundListTrigger={handleUpdateRefundListTrigger} // Pass the function as a prop
            />
          )}
        </ReactDrawer>
      </>
    </>
  );
};

export default BankRefundList;
